export default "__VITE_ASSET__DMVDhaOS__"